export default class ModalNames {
  static COVERED_MODAL: any = "What's Covered?";
  static COVERED_MODAL_1: any = "covered-1";
  static COVERED_MODAL_2: any = "covered-2";
  static FILE_CLAIM_MODAL: any = "File a Claim";
  static MY_POLICY_MODAL: any = "My Policy";
  static FAQ_MODAL: any = "FAQ";
  static PARTNERSHIPS_MODAL: any = "Colleges";
  static CONTACT_MODAL: any = "Contact NSSI";
  static ACCIDENTAL_DAMAGE_MODAL: any = "Accidental Damage Modal";
  static ADD_INTERESTED_PARTY: any = "addInterestedParty";
  static ADD_USER_MODAL: any = "addUserModal";
  static ELECTRONIC_CONSENT_MODAL: any = "electronicConsentModal";
  static DISCLOSURES_MODAL: any = "DisclosuresModal";
  static PAYMENT_AUTHORIZATION_MODAL: any = "PaymentAuthorizationModal";
}
